import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';

import { ViewItemService } from '../COMMON/services/product-view/view-item.service';

import { ZenitEventApiService } from './services/api/zenit-event-api.service';
import { BasicEventParserService } from './services/parser/basic-event/basic-event-parser.service';
import { ZenitEventParserService } from './services/parser/zenit-event-parser.service';
import { AddToCartEventEffects } from './store/effects/add-to-cart-event/add-to-cart-event.effects';
import { ClickEventEffects } from './store/effects/click-event/click-event.effects';
import { ImpressionsHitEventEffects } from './store/effects/impressions-hit-event/impressions-hit-event.effects';
import { PageHitEventEffects } from './store/effects/page-hit-event/page-hit-event.effects';
import { PurchaseConfirmedEventEffects } from './store/effects/purchase-confirmed/purchase-confirmed-event.effects';

import {
    SearchAssistantEventEffects,
} from '@shared/analytics/ZENIT/store/effects/search-assistant-event/search-assistant-event.effects';

@NgModule({
    providers: [
        provideEffects(
            AddToCartEventEffects,
            ClickEventEffects,
            ImpressionsHitEventEffects,
            PageHitEventEffects,
            PurchaseConfirmedEventEffects,
            SearchAssistantEventEffects,
        ),
        BasicEventParserService,
        ViewItemService,
        ZenitEventApiService,
        ZenitEventParserService,
    ],
})
export class ZenitModule { }
